<template>
  <div class="d-contents">
    <v-fade-transition>
      <!-- Pending -->
      <div v-if="surveyFetch.status.value === 'pending'" class="d-flex flex-column" style="height: 100vh">
        <v-progress-linear indeterminate color="primary" />
        <div class="flex-grow-1 d-flex justify-center align-center">
          <span class="text-h4 text-medium-emphasis">
            {{ $t('Loading') }}
          </span>
        </div>
      </div>

      <!-- Route -->
      <SinaSurveySetup v-else-if="survey" :survey="survey">
        <NuxtPage />
      </SinaSurveySetup>

      <!-- 404 -->
      <v-container v-else>
        <v-empty-state
          :headline="$t('Error404')"
          icon="mdi-transmission-tower-off"
          :text="`${$t('Error')}: ${surveyFetch.error.value ? surveyFetch.error.value.message : 'unknown'}`"
        >
          <template #actions>
            <v-btn :to="{ name: Routes.sina }" color="primary" elevation="0" prepend-icon="mdi-arrow-left">
              {{ $t('ButtonBack') }}
            </v-btn>
          </template>
        </v-empty-state>
      </v-container>
    </v-fade-transition>
  </div>
</template>

<script lang="ts">
import { defineComponent, toValue } from 'vue'
import type { SurveyRead } from '@gridcon-energy/schaltungstool-backend'
import { injectBackendClient } from '~/api/backendClients'
import { definePageMeta } from '#imports'
import { Routes } from '~/_routes'
import { useAsyncData } from '#app'
import SinaSurveySetup from '~/components/Sina/SinaSurveySetup.vue'
import { useRouteParams } from '@vueuse/router'
import { useRoute } from '#vue-router'

export default defineComponent({
  name: 'SurveyPages',
  components: { SinaSurveySetup },
  setup() {
    const backend = injectBackendClient()
    const route = useRoute()

    definePageMeta({
      layout: 'application',
      validate(route) {
        const survey = parseInt(route.params.survey as string)
        return !isNaN(survey) && survey > 0 // param is a positive integer
      },
    })

    const surveyId = useRouteParams('survey', String(route.query.activity || 0), { transform: parseInt })
    const id = toValue(surveyId)

    /**
     * Load Survey
     */
    const surveyFetch = useAsyncData(
      async () => {
        const response = await backend.sina.surveysApi.getSurveyDetailed(id)
        return response.data
      },
      { default: () => null },
    )

    return {
      Routes,
      surveyFetch,
    }
  },
  computed: {
    survey() {
      return this.surveyFetch.data.value
    },
  },
})
</script>

<style scoped lang="scss"></style>
